import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, of, switchMap, take } from 'rxjs';

import { AccountContextService } from '@app/core/services/account-context.service';
import { AuthStoreService } from '@app/core/services/auth-store.service';

export const historicalImportDataDropGuard: CanActivateFn = (route) => {
  const accounts = inject(AccountContextService);
  const auth = inject(AuthStoreService);
  const router = inject(Router);
  if (auth.role() === 'partner') return of(router.createUrlTree(['/partner/dashboard']));
  const authorize = () => {
    const capabilities = accounts.selectedAccount()?.capabilities;
    const allowed = capabilities?.canViewImportOperations === true &&
      (route.data?.['requiredCapability'] !== 'canViewReports' || capabilities.canViewReports === true);
    return allowed
      ? true
      : router.createUrlTree([auth.role() === 'partner' ? '/partner/dashboard' : '/dashboard']);
  };

  if (accounts.accounts().length) return of(authorize());
  // Session restoration can start a newer account request while this guard's
  // request is in flight. Authorize after the current account load settles.
  const settled = toObservable(accounts.loading).pipe(filter(loading => !loading), take(1));
  return accounts.loadAccounts().pipe(switchMap(() => settled), map(authorize));
};
